import BaseModelState from './BaseModelState';
/** Provides a mutatable state that can update registered components to the state */
export default class ModelState extends BaseModelState {
    constructor(initialValue) {
        super(initialValue);
    }
    /** Gets the current value of the ModelState */
    get value() {
        return this.getValue();
    }
    /** Sets the current value of the ModelState and invokes all subscriptions */
    set value(value) {
        this.setValue(value);
    }
}
